import { ContextMenu } from '~/components/ContextMenu/ContextMenu';
import { formatResultWeight } from '~/utils/weight';
import { Table } from '~/components/Table/Table';
import { Link } from '~/components/Link/Link';
import { RecordBadge } from './record-badge';
import { formatDate } from '~/utils/date';
import { Result } from '~/apis/ssf';

interface Props {
  results: Result[];
  isLoading: boolean;
}

function Row({ result }: { result: Result }) {
  return (
    <Table.Row>
      <Table.Col>
        <Link to={`/lifters/${result.person.id}`}>
          {result.person.first_name} {result.person.last_name}
        </Link>
      </Table.Col>
      <Table.Col>
        <Link to={`/clubs/${result.club.id}`}>{result.club.name}</Link>
      </Table.Col>
      <Table.Col>{result.group.competition.name}</Table.Col>
      <Table.Col>{result.weight_class.name}</Table.Col>
      <Table.Col>{formatResultWeight(result.total)}</Table.Col>
      <Table.Col>
        <div style={{ display: 'flex', gap: 'var(--size-2)' }}>
          <RecordBadge status={result.district_record_status} label="DR" />
          <RecordBadge status={result.national_record_status} label="SR" />
        </div>
      </Table.Col>
      <Table.Col>{result.group.start ? formatDate(new Date(result.group.start), 'yyyy-mm-dd') : '-'}</Table.Col>
      <Table.Col align="right">
        <Table.Context
          items={[<ContextMenu.Item label="Hantera resultat" key="edit" to={`/records/manage/${result.id}`} />]}
        />
      </Table.Col>
    </Table.Row>
  );
}

export function RecordResultsListTable({ results, isLoading }: Props) {
  return (
    <Table bg="even">
      <Table.Head>
        <Table.Row>
          <Table.Col as="th">Namn</Table.Col>
          <Table.Col as="th">Förening</Table.Col>
          <Table.Col as="th">Tävling</Table.Col>
          <Table.Col as="th">Viktklass</Table.Col>
          <Table.Col as="th">Resultat</Table.Col>
          <Table.Col as="th">Rekordstatus</Table.Col>
          <Table.Col as="th">Datum</Table.Col>
          <Table.Col />
        </Table.Row>
      </Table.Head>

      <Table.Body>
        {isLoading ? <Table.Loading cols={7} /> : results.map(result => <Row result={result} key={result.id} />)}
      </Table.Body>
    </Table>
  );
}
